const setupMobilePurchase=()=>{
  document.querySelectorAll('[data-product-section]').forEach(section=>{
    const primary=section.querySelector('#add-to-cart'),bar=section.querySelector('[data-mobile-purchase]'),button=bar?.querySelector('[data-mobile-add]'),price=bar?.querySelector('[data-mobile-price]'),currentPrice=section.querySelector('[data-current-price]');
    if(!primary||!bar||!button)return;
    const sync=()=>{button.disabled=primary.disabled;button.textContent=primary.textContent;button.setAttribute('aria-busy',primary.getAttribute('aria-busy')||'false');if(price&&currentPrice)price.textContent=currentPrice.textContent;};
    new MutationObserver(sync).observe(primary,{attributes:true,childList:true,subtree:true});
    if(currentPrice)new MutationObserver(sync).observe(currentPrice,{childList:true,subtree:true});
    const observer=new IntersectionObserver(entries=>{const entry=entries[0];bar.hidden=entry.isIntersecting||entry.boundingClientRect.top>=0;},{threshold:0});observer.observe(primary);sync();
  });
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupMobilePurchase,{once:true});else setupMobilePurchase();



const setupSaleCountdown=()=>{
  document.querySelectorAll('[data-sale-countdown]:not([data-countdown-ready])').forEach(timer=>{
    timer.dataset.countdownReady='true';
    const days=Math.max(1,Number.parseInt(timer.dataset.cycleDays||'10',10)||10);
    const duration=days*24*60*60*1000;
    const parsedAnchor=Date.parse(timer.dataset.cycleAnchor||'');
    const anchor=Number.isFinite(parsedAnchor)?parsedAnchor:Date.UTC(2026,9,15);
    const fields={
      days:timer.querySelector('[data-countdown-days]'),
      hours:timer.querySelector('[data-countdown-hours]'),
      minutes:timer.querySelector('[data-countdown-minutes]'),
      seconds:timer.querySelector('[data-countdown-seconds]')
    };
    const label=timer.dataset.countdownLabel||'Sale refreshes in';
    const render=()=>{
      const now=Date.now();
      const target=anchor+(Math.floor((now-anchor)/duration)+1)*duration;
      const remaining=Math.max(0,target-now);
      const values={
        days:Math.floor(remaining/86400000),
        hours:Math.floor((remaining%86400000)/3600000),
        minutes:Math.floor((remaining%3600000)/60000),
        seconds:Math.floor((remaining%60000)/1000)
      };
      if(fields.days)fields.days.textContent=String(values.days).padStart(2,'0');
      if(fields.hours)fields.hours.textContent=String(values.hours).padStart(2,'0');
      if(fields.minutes)fields.minutes.textContent=String(values.minutes).padStart(2,'0');
      if(fields.seconds)fields.seconds.textContent=String(values.seconds).padStart(2,'0');
      timer.setAttribute('aria-label',label+' '+values.days+' days, '+values.hours+' hours, '+values.minutes+' minutes, '+values.seconds+' seconds');
    };
    render();
    window.setInterval(render,1000);
  });
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupSaleCountdown,{once:true});else setupSaleCountdown();
document.addEventListener('shopify:section:load',setupSaleCountdown);
